module.exports = __webpack_public_path__ + "02_mole.561a7ec3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer2/02_mole.png
// module id = pGq8
// module chunks = 0